import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface NavigationButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
  disabled: boolean;
}

export function NavigationButton({ direction, onClick, disabled }: NavigationButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        p-2 rounded-full
        ${disabled ? 'text-[--c-accent]' : 'text-[--c-dark-accent] hover:bg-blue-50'}
        transition-colors duration-200
      `}
      aria-label={direction === 'prev' ? 'Previous question' : 'Next question'}
    >
      {direction === 'prev' ? <ChevronLeft size={24} /> : <ChevronRight size={24} />}
    </button>
  );
}